export default __webpack_public_path__ + "static/media/DocDB.f52ee0a0.svg";